import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _extends from 'babel-runtime/helpers/extends';

var _templateObject = _taggedTemplateLiteral([''], ['']);

import React from 'react';
import ReactSelect from 'react-select';
import styled from 'styled-components';
import { styles } from 'gipsy-misc';
import { lighten } from 'polished';

var primary = styles.colors.buttonDarkColor;
var primary75 = lighten(0.75, primary);
var primary50 = lighten(0.5, primary);
var primary25 = lighten(0.25, primary);

var bgCol = styles.colors.buttonLightColor;

var UnstyledSelect = function UnstyledSelect(p) {
  return React.createElement(ReactSelect, _extends({
    theme: function theme(_theme) {
      return _extends({}, _theme, {
        borderRadius: 8,
        border: 'none',
        colors: _extends({}, _theme.colors, {
          primary: primary,
          primary75: primary75,
          primary50: primary50,
          primary25: primary25,
          neutral0: bgCol,
          neutral5: bgCol,
          neutral10: bgCol,
          neutral20: bgCol,
          neutral30: bgCol,
          neutral40: bgCol,
          neutral50: bgCol,
          neutral60: bgCol,
          neutral70: bgCol,
          neutral80: bgCol,
          neutral90: bgCol
        })
      });
    },
    styles: {
      singleValue: function singleValue(originalStyles) {
        return _extends({}, originalStyles, { color: styles.colors.textRegularColor });
      },
      dropdownIndicator: function dropdownIndicator(originalStyles) {
        return _extends({}, originalStyles, { color: styles.colors.textRegularColor });
      }
    }
  }, p, {
    classNamePrefix: 'react-select'
  }));
};

var Select = styled(UnstyledSelect)(_templateObject);

export default Select;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Select/index.js
// module id = 1103
// module chunks = 0